<template lang="pug">
.container-fluid
  .row
    .col-md-2.pl-0.detailFilter
      .list-group
        a.list-group-item(
          v-for="section in body_fields"
          :key="`index_${section.id}`"
          href="#"
          @click="scrollToSection(section.id)"
        )
          | {{ section.label }}
    .col-md-10.px-5.detailDocument
      h1.my-3(v-if="shownumerotol")
        | {{ numeroTOL }}
      documents-header-vue(
        :clazz="clazz"
        :header_fields="header_fields"
        show-in-box=true
      )
      documents-iter-procesal-vue(
        :id="id"
        :metadata-fields="metadata_fields"
      )
      document-card-vue(
        :metadata-fields="metadata_fields"
      ).mb-3
      documents-section-vue(
        v-for="section in body_fields"
        :key="`section_${section.id}`"
        v-bind="section"
        :cleaned_tokens="cleaned_tokens"
        :ref="section.id"
        :show_all="true"
        :highlight_add_buttons="true"
        :go-up-button-visible="true"
        :links-data="linksData"
      )
      pdf-viewer-vue(
        :path='pdfPath'
        :sofia-enabled="sofiaEnabled"
        @link:clicked="showLinkModal"
        v-if="hasPdfDocument"
      )
      modal-quick-view-vue(:bus="quickViewBus")

      modal-links-vue(
        ref="links_modal"
      )
</template>

<script>
import Vue from 'vue'
import { mapState, mapMutations, mapActions } from 'vuex'
import document_mixin from 'common/mixins/document_mixin'
import token_formatter from 'common/token_formatter'
import { fetchLinks } from 'common/links'

export default {
  name: 'documents-detail-vue',
  props: {
    sofiaEnabled: { type: Boolean, default: false },
    shownumerotol: { type: Boolean, default: false }
  },
  components: {
    'documents-header-vue': () => import(
      /* webpackChunkName: "[request]" */ 'components/documents/Header'
    ),
    'documents-section-vue': () => import(
      /* webpackChunkName: "[request]" */ 'components/documents/Section'
    ),
    'documents-iter-procesal-vue': () => import(
      /* webpackChunkName: "[request]" */ 'components/documents/DocumentsIterProcesal'
    ),
    'document-card-vue': () => import(
      /* webpackChunkName: "[request]" */ 'components/documents/DocumentCard'
    ),
    'modal-quick-view-vue': () => import(
      /* webpackChunkName: "[request]" */ 'components/ModalQuickView'
    ),
    'pdf-viewer-vue':  () => import(
      /* webpackChunkName: "[request]" */ "components/files/PdfViewer"
    ),
    'modal-links-vue': () => import(
      /* webpackChunkName: "[request]" */ "components/ModalLinks"
    ),
  },
  mixins: [document_mixin],
  data() {
    return {
      linksData: {},
      quickViewBus: new Vue()
    }
  },
  computed: {
    pdfPath(){
      return this.file_fields[0] ? this.file_fields[0].url : null
    },
    hasPdfDocument(){
      return this.file_fields[0] ? this.file_fields[0].id.endsWith('.pdf') : false
    },
    cleaned_tokens() {
      return token_formatter.format_and_split_tokens(this.searchTokens)
    },
    ...mapState("search", ['searchTokens'])
  },
  methods: {
    scrollToSection(sectionId) {
      this.$refs[sectionId][0].$el.scrollIntoView({ behavior: 'smooth' })
    },
    openDocumentModal(id) {
      this.quickViewBus.$emit('quick_view:show_document', String(id), '')
    },
    ...mapMutations('document', [
      'setId',
      'setNumeroTol',
      'setClazz',
      'setHeaderFields',
      'setMetadataFields',
      'setIndiceFields',
      'setBodyFields',
      'setFileFields'
    ]),
    showLinkModal( document_ids ){
      const [first, ...rest] = document_ids

      if (rest.length == 0){
        this.openDocumentModal(first)
      }
      else{
        const modalLinksRef = Array.isArray(this.$refs.links_modal) ? this.$refs.links_modal[0] : this.$refs.links_modal
        modalLinksRef.load_links(document_ids)
      }
    },
    async loadLinks() {
      if (this.$links_enabled)
        this.linksData = await fetchLinks(this.id)
    }
  },
  created() {
    this.setId(this.id)
    this.setNumeroTol(this.numeroTOL)
    this.setClazz(this.clazz)
    this.setHeaderFields(this.header_fields)
    this.setMetadataFields(this.metadata_fields)
    this.setIndiceFields(this.indice_fields)
    this.setBodyFields(this.body_fields)
    this.setFileFields(this.file_fields)
    this.loadLinks()

    $(document).on('click', '.tol_link', (link) => {
      let id = $(link.target).data('docid')
      this.openDocumentModal(id)
    })
  }
}
</script>
